module.exports = __webpack_public_path__ + "img/IMG_8157_L_Wood_MockedUp.14048278.jpg";